"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShieldPositiveIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ShieldPositiveIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6061 19.9108C11.8342 20.0299 12.1204 20.0299 12.3485 19.91C18.564 16.6455 19.0054 10.2673 19 8.45372C18.9994 8.30796 18.9553 8.16553 18.8732 8.04388C18.7911 7.92222 18.6744 7.82663 18.5376 7.7688L12.2919 5.06476C12.1925 5.02193 12.085 4.99987 11.9764 5C11.8678 5.00013 11.7604 5.02245 11.6612 5.06552L5.46042 7.77031C5.32559 7.82797 5.21059 7.92235 5.12915 8.04219C5.04771 8.16203 5.00328 8.30226 5.00116 8.44613C4.97478 10.2506 5.34638 16.6424 11.6061 19.9108ZM11.2564 13.0143L9.55141 11.4043L8.5 12.3971L11.2564 15L15.5 10.9928L14.4486 10L11.2564 13.0143Z", fill: "currentColor" }))); };
exports.ShieldPositiveIcon = ShieldPositiveIcon;
